export default {
    path: '/',
    name: 'landing-page',
    component: () => import('source/pages/LandingPageNew2.vue'),
    meta: {
        title: 'HQZen - Find Zen in your workforce',
    },
};
